import { toJS } from '@rehaje/reactive'
import { getProxyRaw, isProxyRawKey, keys, toJSON } from '@rehaje/shared'

import { getEnumerableOwnPropertyDescriptor } from './getEnumerableOwnPropertyDescriptor'

import type { TRecord } from '@rehaje/shared'

export function createArrayLike<T = any>(
  target = {} as T,
  list = [] as T[]
): T & T[] {
  const arrayLikeToJS = () => {
    if (list.length === 1) return toJS(target)
    return { ...toJS(list), ...toJS(target) }
  }
  const arrayLikeToJSON = () => {
    if (list.length === 1) return toJSON(target)
    return { ...toJSON(list), ...toJSON(target) }
  }

  return new Proxy<any>(target, {
    get(target: TRecord, key) {
      if (isProxyRawKey(key)) return getProxyRaw(target)
      if (key === 'toJS') return arrayLikeToJS
      if (key === 'toJSON') return arrayLikeToJSON
      if (key in target) return target[key]
      const value = list[key as keyof typeof list]
      if (typeof value === 'function') return value.bind(list)
      return value
    },
    getOwnPropertyDescriptor(target, key) {
      if (key in target) {
        return getEnumerableOwnPropertyDescriptor(target, key)
      }
      return getEnumerableOwnPropertyDescriptor(list, key)
    },
    has(target, key) {
      if (list.length === 1) return key in target
      return key in target || key in list
    },
    ownKeys(target) {
      if (list.length === 1) return keys(target)
      return [...keys(target), ...keys(list)]
    }
  }) as T & T[]
}
